import { createRouter, createWebHashHistory } from 'vue-router'

// import MeasurementResultView from '../views/MeasurementResultView.vue'
import MeasurementResult2View from '../views/MeasurementResult2View.vue'

import HouseMapView from '../views/HouseMapView.vue'

import CommandCommunicationView from '../views/CommandCommunicationView.vue'

const routes = [
  {
    path: '/',
    redirect: '/measurement-result'
  },

  {
    path: '/measurement-result',
    name: 'measurement-result',
    component: MeasurementResult2View
  },
  {
    path: '/measurement-result2',
    name: 'measurement-result2',
    component: MeasurementResult2View
  },

  {
    path: '/house-map',
    name: 'house-map',
    component: HouseMapView
  },

  {
    path: '/command-communication',
    name: 'command-communication',
    component: CommandCommunicationView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// iPhoneでホーム画面に追加した際に2つ目の'#'がURLエンコードされてしまうため対処
// Teamsでリンク共有した際に「'」がURLエンコードされてしまうため対処
router.beforeEach((to, from, next) => {

  if (to.fullPath.includes('%23') || to.fullPath.includes('%27')) {
    window.location.href = '#' + to.fullPath.replaceAll('%23', '#').replaceAll('%27', "'");
    window.location.reload();
  } else {
    next();
  }

});

export default router
